export const Context = {
  IFRAME: "iframe",
  PARENT: "parent",
};
